import React, { Component } from 'react';
import './Deals.css';
import {DealItem} from './DealItem'
import SimpleSlider from '../SimpleSlider/SimpleSlider';
import { Img } from '../UI/UI';
import { getImgUrl , limitText } from "../../Utility/Utility"


class Deals extends Component {
  
  constructor (props){
  	super(props);
  	this.image_url = getImgUrl();
  	
  	this.dealsSliderSettings = {
      	dots: true,
      	infinite: true,
      	cssEase: 'linear',
      	autoplay:false,
      	lazyLoad: "ondemand",
      	slidesToShow: (this.props.items != undefined  ) ? this.props.items : 3,
		slidesToScroll: 1,
		responsive: [
	        {
	          breakpoint: 1000,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 2
	          }
	        },
	        {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }
      	]
    };

  	  	this.deals = [

  	  	                    {
								title: "Wizzair",
								desc : "Flights to Ben Gurion from £69 per person one way" ,
								price : "£69" ,
								logo: "/Deals/en/26.png" ,
								link : "https://wizzair.com/en-gb/flights/timetable#" ,
								book_now : "BOOK NOW"
							},

							{
								title: "Easyjet",
								desc : "Flights to ben Gurion start from price p.p one way" ,
								price : "£94" ,
								logo: "/Deals/en/25.jpg" ,
								link : "http://www.easyjet.com/en/cheap-flights/israel/tel-aviv" ,
								book_now : "BOOK NOW"
							},

							{
								title: "El Al",
								desc : "Flights to Ben Gurion price p.p return from Luton" ,
								price : "£239" ,
								logo: "/Deals/en/elal.png" ,
								link : "https://www.elal.com/en/UK/Deals/Pages/Tube-Promo.aspx" ,
								book_now : "BOOK NOW"
							},

							{
								title: "Expedia",
								desc : "3 night breaks in February inclucing flights + hotel start at £259 pp, based on 2 sharing" ,
								price : "£259 " ,
								logo: "/Deals/en/24.png" ,
								link : "https://www.expedia.co.uk/Hotel-Search?packageType=fh&c=dc02150f-8a02-4e01-b8f2-94def4ed5ec4&ttla=TLV&ftla=LON&tripType=ROUND_TRIP&misId=AgioiPWWs8HXrHcQ4OSwv8jn-emWASCG09MP&origin=London,+United+Kingdom+(LON-All+Airports)&destination=Tel+Aviv,+Israel+(TLV-All+Airports)&startDate=27/2/2020&endDate=1/3/2020&checkInDate=27/2/2020&checkOutDate=1/3/2020&adults=2&infantsInSeats=0&cabinClass=e&regionId=6139196&sort=price&filterSelected=true" ,
								book_now : "BOOK NOW"
							},
							// {
							// 	title: "VIRGIN ATLANTIC",
							// 	desc : "Return airfare starts at just £269 per person " ,
							// 	price : "£269 " ,
							// 	logo: "/Deals/en/virginen.jpg" ,
							// 	link : "https://www.virginatlantic.com/gb/en/destinations/israel.html" ,
							// 	book_now : "BOOK NOW"
							// },

							{
								title: "British Airways Holidays",
								desc : "Return airfare on British Airways starts at £269 per person.",
								price : "£269",
								logo: "/Deals/en/3.png",
								link : "https://www.britishairways.com/travel/low-price-finder/public/en_gb?eId=113021&oneway=false&retDate=30/01/20&cabin=M&destination=TLV&origin=LHR&numNights=3&region=MDE",
								book_now : "BOOK NOW"
							},

							{
								title: "Expedia",
								desc : "3nts hotel in Jerusalem inc. return flights. Cost pp, based on 2 sharing" ,
								price : "£279 " ,
								logo: "/Deals/en/24.png" ,
								link : "https://www.expedia.co.uk/Hotel-Search?packageType=fh&c=3d192fe1-c197-4215-ac1b-4bc99f34db18&ttla=TLV&ftla=LTN&tripType=ROUND_TRIP&misId=AgiwgdminfeV5CQQ2qSzl9fC-aawASCI0NMP&origin=London,+United+Kingdom+(LTN-Luton)&destination=Jerusalem+(and+vicinity),+Israel&startDate=27/2/2020&endDate=1/3/2020&checkInDate=27/2/2020&checkOutDate=1/3/2020&adults=2&infantsInSeats=0&cabinClass=e&Direct=1&regionId=178271&sort=price&filterSelected=true" ,
								book_now : "BOOK NOW"
							},

							{
								title: "Tel Aviv Hotels",
								desc : "Discover Tel Aviv City Break Free Dinner for Two" ,
								price : "£105" ,
								logo: "/Deals/en/tlv-hotels.png" ,
								link : "https://www.visit-tel-aviv.com/en/promotions/telaviv" ,
								book_now : "BOOK NOW"
							},

							{
								title: "Crusader Travel",
								desc : "3nt/4day package in Tel Aviv  inc accommodation, transfers & tours (flight not included)" ,
								price : "£285" ,
								logo: "/Deals/en/30.jpg" ,
								link : "http://www.crusadertravel.com/experience/israel-long-weekend-break/" ,
								book_now : "BOOK NOW"
							},

							{
								title: "Travelink",
								desc : "3 night break in Jerusalem including flights and hotel",
								price : "£398",
								logo: "/Deals/en/11.png",
								link : "https://www.travelinkuk.com/offers",
								book_now : "BOOK NOW"
							},
							{
								title: "British Airways Holidays",
								desc : "3 nights in Tel Aviv inc. return flights on British Airways",
								price : "£419",
								logo: "/Deals/en/3.png",
								link : "https://www.britishairways.com/en-gb/destinations/tel-aviv/tel-aviv-holidays",
								book_now : "BOOK NOW"
							},

							

							{
								title: "ANA",
								desc : "2 nights with a breakfast in one of our   locations around Israel + 3 tickets   to Israel's nature parks & reserves" ,
								price : "£76 " ,
								logo: "/Deals/en/22.png" ,
								link : "http://www.iyha.org.il/wp-content/uploads/languages/citybreak.html" ,
								book_now : "BOOK NOW"
							},
							
							
							
				           
							{
								title: "On The Beach",
								desc : "3 night break in Tel Aviv including flights & hotel" ,
								price : "£479" ,
								logo: "/Deals/en/50.png" ,
								link : "https://www.onthebeach.co.uk/destinations/israel/tel-aviv" ,
								book_now : "BOOK NOW"
							},
							{
								title: "Lastminute",
								desc : "4-night break including hotel & return flights from £491 pp, based on 2 sharing" ,
								price : "£491" ,
								logo: "/Deals/en/51.png" ,
								link : "https://www.lastminute.com/holidays/israel.html" ,
								book_now : "BOOK NOW"
							},
							{
								title: "West End Travel",
								desc : "3 nights hotel in Tel Aviv & return flights from the UK" ,
								price : "£499" ,
								logo: "/Deals/en/40.jpg" ,
								link : "http://www.westendtravel.co.uk/israel/tel-aviv/" ,
								book_now : "BOOK NOW"
							},
							{
								title: "Travelink",
								desc : "3-night break in Tel Aviv at the TLV88 hotel on a B&B basis, inc. return flights from Luton and a day tour to Jerusalem (based on 2 sharing)",
								price : "£521",
								logo: "/Deals/en/11.png",
								link : "https://www.travelinkuk.com/offer/2d48a7c2-6a5d-4950-9951-ab5e00dce56e",
								book_now : "BOOK NOW"
							},
							{
								title: "Virgin Holidays",
								desc : "4 night break in Tel Aviv on a B&B basis, including return flights on Virgin Atlantic",
								price : "£566",
								logo: "/Deals/en/virgin-holidays.jpg",
								link : "https://www.virginholidays.co.uk/destinations/middle-east/israel-offers",
								book_now : "BOOK NOW"
							},

							{
								title: "Lastminute",
								desc : "4 nights in a 4* hotel on a B&B basis in Tel Aviv including return flights. " ,
								price : "£599" ,
								logo: "/Deals/en/51.png" ,
								link : "https://www.lastminute.com/holidays/israel.html" ,
								book_now : "BOOK NOW"
							},

							
							{
								title: "Holiday Designers",
								desc : "4 nights B&B at the Daniel Hotel in Herzliya inc flights & transfers",
								price : "£665",
								logo: "/Deals/en/13.png",
								link : "http://www.holiday-designers.com/israel/herzliya/the-daniel-hotel-herzliya/prices",
								book_now : "BOOK NOW"
							},
							{
								title: "Holiday Designers",
								desc : "4 night B&B at the Metropolitan Hotel in Tel Aviv,  inc return flights",
								price : "£709",
								logo: "/Deals/en/13.png",
								link : "http://www.holiday-designers.com/israel/tel-aviv/metropolitan/prices",
								book_now : "BOOK NOW"
							},

							{
								title: "Mosaic Holidays",
								desc : "5 nights B&B in Jerusalem inc full day city tour & return flights",
								price : "£719",
								logo: "/Deals/en/42.png",
								link : "http://mosaicholidays.co.uk/Destinations/Israel/JERUSALEM",
								book_now : "BOOK NOW"
							},
							{
								title: "Holiday Designers",
								desc : "4 nights B&B in Jerusalem at Dan Boutique inc. flights and transfers",
								price : "£735",
								logo: "/Deals/en/13.png",
								link : "http://www.holiday-designers.com/jerusalem-city-break-offers",
								book_now : "BOOK NOW"
							},
							{
								title: "Holiday Designers",
								desc : "5 night at a 5* hotel in Jerusalem, including return flights on Virgin Atlantic",
								price : "£738",
								logo: "/Deals/en/13.png",
								link : "https://www.virginholidays.co.uk/holiday/jerusalem/dan-panorama-jerusalem/options?departureDate=31-01-2020&duration=5&gateway=LHR&room=a2,i0&searchType=deal",
								book_now : "BOOK NOW"
							},

							{
								title: "Holiday Designers",
								desc : "4 nights B&B in Jerusalem at Harmony Hotel including flights and transfers",
								price : "£769",
								logo: "/Deals/en/13.png",
								link : "http://www.holiday-designers.com/jerusalem-city-break-offers",
								book_now : "BOOK NOW"
							},

							{
								title: "Out of Office",
								desc : "3 nights hotel in Tel Aviv" ,
								price : "£795 " ,
								logo: "/Deals/en/8.png" ,
								link : "https://www.outofoffice.com/israel/tel-aviv-city-break/" ,
								book_now : "BOOK NOW"
							},

							

							{
								title: "Virgin Holidays",
								desc : "5 night break at a 5* hotel in Jerusalem on a B&B basis, inc return flights on Virgin Atlantic",
								price : "£859",
								logo: "/Deals/en/virgin-holidays.jpg",
								link : "https://www.virginholidays.co.uk/holiday/jerusalem/dan-panorama-jerusalem/options?departureDate=31-01-2020&duration=5&gateway=LHR&room=a2,i0&searchType=deal",
								book_now : "BOOK NOW"
							},

							{
								title: "Holiday Designers",
								desc : "4 nights B&B in Jerusalem at the Mamilla Hotel inc flights & transfers",
								price : "£1,075",
								logo: "/Deals/en/13.png",
								link : "http://www.holiday-designers.com/jerusalem-city-break-offers",
								book_now : "BOOK NOW"
							},
				            
						    

							
							{
								title: "Kuoni",
								desc : "5-night luxury break in Tel Aviv & Jerusalem . Quote Tour Ref: IL0025",
								price : "£1,179",
								logo: "/Deals/en/kuoni.jpg",
								link : "https://www.kuoni.co.uk/asia/israel-and-jordan/israel",
								book_now : "BOOK NOW"
							},
							{
								title: "Cox & Kings",
								desc : "5-night / 6-day luxury break of Tel Aviv & Jerusalem inc. flights, hotel & private transfers",
								price : "£2,595",
								logo: "/Deals/en/cox.png",
								link : "https://www.coxandkings.co.uk/destinations/middle-east/israel/private-travel/tel-aviv-and-jerusalem-short-break-superior",
								book_now : "BOOK NOW"
							},
							{
								title: "Abercrombie & Kent",
								desc : "3-night ultra luxury Jerusalem holiday that includes a private guide ",
								price : "£2,610",
								logo: "/Deals/en/.png",
								link : "https://www.abercrombiekent.co.uk/destinations/north-africa-and-middle-east/israel/highlights-of-jerusalem",
								book_now : "BOOK NOW"
							},
							{
								title: "Audley Travel",
								desc : " 7-day ultra-luxury private tour of Tel Aviv & Jerusalem inc. flights, transfers, excursions & accom.",
								price : "£4,620",
								logo: "/Deals/en/audley.jpg",
								link : "https://www.audleytravel.com/israel/tours/tel-aviv-and-jerusalem",
								book_now : "BOOK NOW"
							}
				   

  	  	]

  }

  render() {


  	const dealsHtml = this.deals.map((o)=>{
  		return <DealItem 
		            key={ o.title }
  					brand={ o.title } 
  					price={ o.price } 
  					brandImg={ o.logo } 
  					desc={ o.desc } 
  					bookNowLink={o.link}
  					descFontSize={ o.fontSize }
				/>
  	})
    return (
	      <div className="deals-wrapper">
        	<SimpleSlider settings={this.dealsSliderSettings}>
	           {dealsHtml}
          	</SimpleSlider>
	      </div>
    );
  }
}

export default Deals;



// WEBPACK FOOTER //
// ./src/Components/Deals/Deals.js